
import React from 'react';

export interface MediaCardProps {
  title: string;
  date: string;
  description: string;
  tags: string[];
  link: string;
  thumbnail: string;
}

const MediaCard: React.FC<MediaCardProps> = ({ title, date, description, tags, link, thumbnail }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column' as const }}
      className="group"
    >
      {/* Thumbnail */}
      <div style={{ position: 'relative', overflow: 'hidden', backgroundColor: '#1A1916' }}>
        <img
          src={thumbnail}
          alt={title}
          loading="lazy"
          width={640}
          height={360}
          style={{ width: '100%', aspectRatio: '16/9', objectFit: 'cover', display: 'block', opacity: 0.85, transition: 'opacity 0.3s' }}
          className="group-hover:opacity-100"
        />
        {/* Play overlay */}
        <div
          className="group-hover:opacity-100"
          style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0, transition: 'opacity 0.3s', backgroundColor: 'rgba(11,11,11,0.4)' }}
        >
          <div style={{ width: '56px', height: '56px', backgroundColor: '#FF4500', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="#0B0B0B"><path d="M8 5v10l8-5-8-5z"/></svg>
          </div>
        </div>
        {/* Date badge */}
        <div style={{ position: 'absolute', top: '1rem', left: '1rem', backgroundColor: 'rgba(11,11,11,0.85)', padding: '3px 10px' }}>
          <span style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.6rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#8C8377' }}>{date}</span>
        </div>
      </div>

      {/* Content */}
      <div style={{ backgroundColor: '#0B0B0B', borderTop: '2px solid rgba(255,69,0,0.3)', padding: '1.75rem', flexGrow: 1, display: 'flex', flexDirection: 'column' as const, gap: '0.75rem' }}>
        <h3 style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: 'clamp(1.3rem, 3vw, 1.8rem)', lineHeight: 0.95, letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#F2EDE3', margin: 0 }}>
          {title}
        </h3>
        <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: '0.9rem', lineHeight: 1.6, color: '#8C8377', margin: 0, flexGrow: 1 }}>
          {description}
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap' as const, gap: '0.4rem', marginTop: '0.5rem' }}>
          {tags.map((tag) => (
            <span key={tag} style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.6rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#FF4500', border: '1px solid rgba(255,69,0,0.3)', padding: '3px 8px' }}>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
};

export default MediaCard;
